export const formatCompact = (value: number): string => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`
  }

  if (value >= 1000) {
    return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`
  }

  return String(value)
}

// userEngagementDuration приходит суммой секунд по всем юзерам —
// показываем среднее на пользователя.
export const formatEngagement = (
  totalSeconds: number,
  users: number
): string => {
  const seconds = users > 0 ? Math.round(totalSeconds / users) : 0
  const minutes = Math.floor(seconds / 60)
  const rest = seconds % 60

  return `${minutes}:${String(rest).padStart(2, '0')}`
}
